var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCart = function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 21,
    viewBox: "0 0 30 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#dac7fa",
    d: "M24.112 16.646a2.177 2.177 0 1 0 0 4.353 2.177 2.177 0 0 0 0-4.353M10.527 18.823a2.177 2.177 0 1 1 4.354 0 2.177 2.177 0 0 1-4.354 0M29.243.695A1.5 1.5 0 0 0 28.1.166H13.302a1.5 1.5 0 1 0 0 3h13.03l-1.108 6.732a2.475 2.475 0 0 1-2.45 2.08H12.172L8.604 1.196A1.5 1.5 0 0 0 7.18.165H1.663a1.5 1.5 0 1 0 0 3h4.434L9.664 13.95a1.5 1.5 0 0 0 1.424 1.029h11.686a5.46 5.46 0 0 0 5.41-4.592L29.58 1.91a1.5 1.5 0 0 0-.337-1.215"
  })));
};
export default SvgCart;